import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Input } from '@pergas-common/pergas-components'
import { connect, useSelector } from 'react-redux'
import redux from '../redux'
import { makeSelectorUserdata } from '../redux/login/selectors'
import { selectLocale } from '../redux/locale/selectors'

const ENTER = ['Enter', 'NumpadEnter']

const SearchInput = ({
  selected,
  searchValue,
  showSearchResults,
  isSearching,
  strings,
  onGetTemplatesRootFolder,
  onSearchValueChange,
  onStartSearch,
  onResetSearch
}) => {
  const locale = useSelector(selectLocale)
  const [input, setInput] = useState('')

  const selectUserdata = useMemo(makeSelectorUserdata, [])
  const userData = useSelector((state) => selectUserdata(state))

  const quickKeysEvent = useCallback((event) => {
    if (event.code === 'Escape' || input === '') {
      onGetTemplatesRootFolder()
      onResetSearch()
      setInput('')
    }

    if (ENTER.includes(event.key) && input.length >= 2) {
      onStartSearch({ url: `${userData.sc_root}_admin` }, input)
    }
  }, [input, userData, onGetTemplatesRootFolder, onResetSearch, onStartSearch])

  useEffect(() => {
    document.addEventListener('keydown', quickKeysEvent)
    return () => {
      document.removeEventListener('keydown', quickKeysEvent)
    }
  }, [quickKeysEvent])

  return (
    <Input
      name='search' value={input} onChangeValue={(input) => {
        setInput(input.currentTarget.value)
      }} placeholder={`${locale.search_for_template}...`}
    />
  )
}

const mapStateToProps = (state) => {
  const {
    searchValue,
    showSearchResults,
    isSearching
  } = state.templates
  return {
    strings: state.locale.strings,
    selected: state.selected,
    searchValue,
    showSearchResults,
    isSearching
  }
}

const mapDispatchToProps = (dispatch) => {
  const { templates } = redux.actions
  return {
    onGetTemplatesRootFolder: () => {
      dispatch(templates.getTemplatesRootFolder())
    },
    onSearchValueChange: (value) => {
      dispatch(templates.setSearchValue(value))
    },
    onStartSearch: (current, searchValue) => {
      dispatch(templates.searchFiles(current, searchValue))
    },
    onResetSearch: () => {
      dispatch(templates.resetSearch())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchInput)
